<div class="service-selection-form-container">
    <form class="service-selection-form" [formGroup]="serviceForm">
        
        <div class="section service-section">
            <div class="form-grid">
                <div class = "form-item">
                    <label for="serviceId" class="search-label required_field_label">Service</label>
                    <app-autocomplete-dropdown
                        id="serviceId"
                        class = "autocomplete-dropdown"
                        [formControlName]="'serviceId'"
                        [(ngModel)] = "serviceSearchQuery"
                        [placeholder]="'Select service'"
                        [apiUrl]="'v1/services/list'"
                        [selectFields]="['id', 'name']"
                        [filterByKeys]="['NAME_CONTAINS']"
                        [limit]="10"
                        [orderBy]="{ name: 'asc' }"
                        [bindLabel]="'name'"
                        [bindValue]="'id'"
                        [displayColumns]="[
                            { key: 'name', header: 'Name' },
                        ]"
                        [additionalFilters]="additionalFilters"
                        [returnRawValue]="true"
                        (suggestionSelected) = "onServiceSelection($event)"
                        (searchCleared)="serviceSearchCleared()"
                        >
                    </app-autocomplete-dropdown>
                    <div class="form_validation_error_new" [ngClass]="{'visible': serviceForm.get('serviceId')?.invalid && serviceForm.get('serviceId')?.touched}">
                        <small *ngIf="serviceForm.get('serviceId')?.errors?.['required']">Symbol is required</small>
                    </div>
                </div>
        
                <div class = "form-item">
                    <label for="vendorId" class="required_field_label">Vendor</label>
                    <app-multi-select
                    #vendorDropdown
                        id="vendorId"
                        [formControlName]="'vendorId'"
                        [(options)]="serviceVendorList"
                        [displayKey]="'vendorName'"
                        [valueKey]="'vendorId'"
                        [isMultiSelect]="false"
                        [returnRawValue]="true"
                        [placeholder]="'Select Vendor'"
                        [disable]="serviceVendorList.length < 1"
                      ></app-multi-select>
                      <div class="form_validation_error_new" [ngClass]="{'visible': serviceForm.get('vendorId')?.invalid && serviceForm.get('vendorId')?.touched}">
                        <small *ngIf="serviceForm.get('vendorId')?.errors?.['vendorId']">Vendor is required</small>
                    </div>
                </div>

                <div class = "form-item">
                    <label for="equipmentIds" class="required_field_label">Equipment</label>
                    <app-multi-select
                    #equipmentDropdown
                        id="equipmentIds"
                        [formControlName]="'equipmentIds'"
                        [(options)]="serviceEquipmentList"
                        [displayKey]="'equipmentName'"
                        [valueKey]="'equipmentId'"
                        [isMultiSelect]="true"
                        [returnRawValue]="true"
                        [placeholder]="'Select Equipments'"
                        [disable]="serviceEquipmentList.length < 1"
                        [showChips]="false"
                      ></app-multi-select>
                      <div class="form_validation_error_new" [ngClass]="{'visible': serviceForm.get('serviceId')?.invalid && serviceForm.get('serviceId')?.touched}">
                        <small *ngIf="serviceForm.get('serviceId')?.errors?.['required']">Equipments are required</small>
                    </div>
                </div>
                <div class="form-item" *ngIf="allowInventorySelection">
                    <label for="inventoryIds" class="required_field_label">Apply for {{inventoryType.value}}</label>
                    <app-multi-select
                    id="inventoryIds"
                    [options]="inventoryOptions"
                    [returnRawValue]="false"
                    [displayKey]="'value'"
                    [valueKey]="'key'"
                    [isMultiSelect]="true"
                    [placeholder]="'Select ' + inventoryType.value + 's'"
                    [formControlName]="'inventoryIds'"
                    [showChips]="false"
                    >
                    </app-multi-select>
                    <div class="form_validation_error_new" [ngClass]="{'visible': serviceForm.get('inventoryIds')?.invalid && serviceForm.get('inventoryIds')?.touched}">
                        <small *ngIf="serviceForm.get('inventoryIds')?.errors?.['required']">{{inventotyType}} selection is required</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="divider" *ngIf="attributes.length > 0"></div>

        <div class="section attribute-section" *ngIf="attributes.length > 0">

            <div class="section-title">Configure Service Attributes</div>

            <div class="form-grid">
                <ng-container *ngFor="let attr of attributes; let i = index">
                  <div class="form-item">
                    <label [for]="attr.symbol" [class.required]="attr.mandatory" [ngClass]="{'required_field_label': attr.mandatory}">
                      {{ attr.name }}
                    </label>
                    
                    <ng-container [ngSwitch]="attr.dataType">
                      <input *ngSwitchCase="'STRING'"
                            [id]="attr.symbol"
                            [formControlName]="attr.symbol"
                            type="text"
                            [placeholder]="'Enter ' + attr.name"
                            [required]="attr.mandatory">
            
                      <input *ngSwitchCase="'BIGDECIMAL'"
                            [id]="attr.symbol"
                            [formControlName]="attr.symbol"
                            type="number"
                            step="0.01"
                            [placeholder]="'Enter ' + attr.name"
                            [required]="attr.mandatory">

                        <app-multi-select *ngSwitchCase="'BOOLEAN'"
                        [id]="attr.symbol"
                        [options]="booleanOptions"
                        [returnRawValue]="false"
                        [displayKey]="'value'"
                        [valueKey]="'key'"
                        [isMultiSelect]="false"
                        [placeholder]="'Enter ' + attr.name"
                        [formControlName]="attr.symbol"
                        >
                        </app-multi-select>
                    </ng-container>
                  </div>
                </ng-container>
            </div>
        </div>
        
    </form>

    @if (loadedOnModal) {
        
        <div class="divider"></div>
        <div class="action_btns">
          <button class="secondary_button" (click)="onClose()">Cancel</button>
          <button *ngIf="!hidePrimaryButton" class="primary_button"
                  (click)="saveForm()">Save
          </button>
        </div>
      }
</div>